module.exports = __webpack_public_path__ + "static/media/ic-social-linkedin.f6992da6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-social-linkedin.svg
// module id = 670
// module chunks = 14